import React, { useState, useEffect } from "react";
import styles from "./captcha.module.css";
export const Captcha = ({ captcha, setCaptcha }) => {
  useEffect(() => {
    const captchas = generateString(6);
    setCaptcha(captchas);
  }, []);

  return (
    <div>
      <div className={styles.captchaMainDiv}>
        <div className={styles.captchaImgDiv}>
          <h4 className={styles.captchaText}>{captcha}</h4>
        </div>
      </div>
    </div>
  );
};
export const generateString = (length = 6) => {
  const characters = "ABCDEFGHIJKLMNOPQ123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
export const validateCaptcha = (captcha, captchaValue) => {
  console.log(captcha, captchaValue);
  if (captcha == captchaValue) {
    return true;
  } else {
    return false;
  }
};
